<template>
  <div class="all">
    <img src="../assets/img/title.png" class="title" />
    <van-form @submit="onSubmit">
      <van-field readonly clickable name="picker" :value="viewname" label="表单名称" placeholder="点击选择表单"
        @click="show = true" :rules="[{ required: true, message: '请选择表单' }]" />

      <van-field v-if="party" readonly clickable name="picker" :value="partyname" label="会议名称" placeholder="点击选择会议"
        @click="showParty = true" :rules="[{ required: true, message: '请选择会议' }]" />
      <van-field v-model="username" name="用户名" label="用户名" placeholder="用户名"
        :rules="[{ required: true, message: '请填写Ids账号' }]" />
      <div style="margin: 16px;">
        <van-button size="small" round block type="info" native-type="submit">提交</van-button>
      </div>
      <iframe v-if="iframeshow" style="width:100%;height:600px" allowfullscreen :src=iframe></iframe>
      <div v-if="iframeshow" style="margin: 16px;">
        <van-button size="small" round block type="primary" @click="downloadfile">下载</van-button>
      </div>

    </van-form>

    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }" round>
      <van-picker title="表单名称" show-toolbar :columns="viewlist" @confirm="onConfirm" @cancel="onCancel"
        value-key="name" />
    </van-popup>
    <van-popup v-model="showParty" position="bottom" :style="{ height: '40%' }" round>
      <van-picker title="会议名称" show-toolbar :columns="options4" @confirm="onConfirm2" @cancel="onCancel2"
        value-key="name" />
    </van-popup>

    <van-overlay :show="iframeloading" style="    padding-top: calc(50vh - 20px);">
      <van-loading color="#1989fa" />
    </van-overlay>
    <div class="aaaa">
      <!-- <iframe v-if="iframeshow" style="width:100%;height:600px" allowfullscreen 
      :src=iframe
      ></iframe> -->
      <!-- <vs-card>
        <template #img>
          <div style="width: 450px">
            <pdf ref="pdf" @loaded="loadover()" :src="url"> </pdf>
          </div>
        </template>
<template #text>

        </template>
</vs-card> -->
<a href="javascript:void(0);" id="oDownLoad" style="display:none;">下载a</a>
    </div>


  </div>
</template>

<script>

 // import pdf from "vue-pdf";
import { signpdf, getDownload, getView, getViewInfo, GroupByHYMC } from "@/api/data/view"; //
// import { triggerRef } from "vue";
export default {
  // components: {
  //   pdf,
  // },
  data() {
    return {
      select1: '',
      iframeloading:false,
      iframeshow:false,
      iframe:``,
      docurl:'https://localhost:44363/AuthorPdf?PrintId=1d36e538-236f-4897-8095-34f2f8d8ab80&filename=1.pdf',
      columns: [
        {
          values: [],
        },
      ],
      viewname: '',

      value2: '',
      newlist: [],
      selectloading: true,
      username: "",
      selectview: '',
      src: "",
      name: "",
      loading: null,
      url: null,
      prindid: null,
      viewid: null,
      viewlist: [],
      options4: [],
      value1: '',

      party: false,
      showParty: false,
      partyname:'',

      show: false,
    };
  },
  methods: {
    showPartyFun() {
      this.showParty = true;
    },
    showPopup() {
      this.show = true;
    },
    onConfirm2(value) {
      console.log(value, 'value');
      this.partyname = value;
      this.showParty = false;
    },
    onCancel2() {
      this.showParty = false;
    },
    onCancel() {
      this.show = false;
    },
    onConfirm(value) {
      this.show = false;
      this.viewid = value.id,
        this.viewname = value.name
      if (value.name && value.name.indexOf('温州医科大学研究生院-导师培训证明') > -1) {
        this.party = true;
      }
      else {
        this.party = false;
      }
    },

    async getlist() {
      this.options4 = await GroupByHYMC();
    },
    async downloadfile() {
      let path = await getDownload(this.prindid);

      const u = navigator.userAgent;
      console.log(u, "u");
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // 安卓终端使用iframe
        window.open(path);
      } else if (isiOS) {
        navigator.clipboard.writeText(path).then(
          () => {
            this.$vs.notification({
              color: "success",
              position: "top-center",
              title: "复制成功",
              text: "在新页面中打开下载",
            });
          },
          (res) => {
            console.log(res);
            this.$vs.notification({
              color: "success",
              position: "top-center",
              title: "复制失败",
              text: "在新页面中打开" + path,
            });
          }
        );
      } else {
        // 1.如果是地址
        window.open(path);
        //2.如果是文件流
      }
    },
    signpdffun() {
      console.log(this.viewid, "viewid");
      // signpdf(this.viewid, this.username,this.partyname).then(
      //   (res) => {
      //     this.prindid = res;
      //     this.url =
      //       process.env.VUE_APP_BASE_API + "/AuthorPdf?PrintId=" + this.prindid;
      //   },
      //   () => {
      //     this.loading.close();
      //   }
      // );


      try{
        this.iframeloading = true;
        signpdf(this.viewid,this.username,this.partyname).then(
        (res) => {

          this.prindid = res;
          this.url =
            process.env.VUE_APP_BASE_API + "/AuthorPdf?PrintId=" + this.prindid +"&filename=1.pdf";

          // this.docurl = this.url;
          // this.url = "https://bddy.wmu.edu.cn/AuthorPdf?PrintId=ee22b3bb-c3ab-48a8-a056-9ada84350844";
          // this.iframe = `https://verify.ink/viewer?url=${this.url}&search=false&sign=false&show-signature-if-present=false&notify-if-not-signed=false&download=true&filename=1.pdf`
          this.iframeshow = true;
        }
      ).catch(error=>{
        console.log(error)
      })
      .finally(_=>{
        console.log(_);
        this.iframeloading = false;
      })
      }catch(error){
        console.log(error);
      }
    },
    loadover() {
      this.loading = false;
    },
    getView() {
      this.selectloading = true;
      getView().then(res => {
        this.viewlist = res.items;
        this.newlist = this.viewlist.map(t => t.name);
        this.selectloading = false;
      })
    },
    async onSubmit() {
      if (this.viewid && this.username) {
        let res = await getViewInfo(this.viewid);
        this.name = res.name;
        // this.loading = this.$vs.loading({
        //   type: "corners",
        // });
       // this.iframeshow = true;
        this.signpdffun();
      }
      else {
        this.$vs.notification({
          color: 'danger',
          position: 'top-center',
          title: '错误信息',
          text: '存在信息尚未填写',
          icon: "<i class='bx bx-error' ></i>",
          onDestroy: () => {
          }
        });
      }

    }
  },
  created() {
    this.getView();
  },
  async mounted() {
    await this.getlist();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vs-card {
  max-width: 375px;
  padding-top: 20px;
}

.title {
  width: 55%;
  max-width: 300px;
}

.all {
  background: #f5f5f5;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  padding: 2rem 0.2rem;
  box-sizing: border-box;
  overflow-y: auto;
}

.select {
  margin: 1rem auto;
  max-width: 375px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 34.75px;
  border-radius: 20px;
  flex-direction: column;
  box-sizing: border-box;
}

.aaaa {
  margin-top: 5vh;
}

iframe {
  border: 0px;
  height: 420px;
  width: 100%;
}

::v-deep .vs-card {
  margin: auto;
}

.select_box {
  margin: 0.5rem 0;
  width: 100%;

  .vs-input-content {
    width: 100%;
  }
}

::v-deep .vs-select-content,
::v-deep .vs-input {
  max-width: 300px;
  width: 300px;
}

::v-deep .vs-card__img {
  max-height: 500px;
  padding-top: 1rem;
}

@media screen and (min-height: 667px) {
  .all {
    padding: 1rem 0.2rem;
  }

  .aaaa {
    margin-top: 1vh;
  }
}

@media screen and (min-height: 700px) {
  .all {
    padding: 3rem 0.2rem;
  }

  .aaaa {
    margin-top: 2vh;
  }
}

@media screen and (min-height: 800px) {
  .all {
    padding: 3rem 0.2rem;
  }

  .aaaa {
    margin-top: 2rem;
  }
}

@media screen and (min-height: 896px) {
  .all {
    padding: 3rem 0.2rem;
  }

  .aaaa {
    margin-top: 2rem;
  }
}
</style>